

// export const BASE_URL = 'http://72.62.193.59'

export const BASE_URL = 'https://www.cutybird.cloud'



